import React, { useEffect, useRef } from 'react';
import { FaMapMarkerAlt, FaMedal, FaRocket } from 'react-icons/fa';

const REASONS = [
    {
        icon: <FaMapMarkerAlt />,
        title: 'Local Expertise, Global Standards',
        desc: "Deep roots in Sierra Leone's business culture combined with internationally recognised frameworks and best practices.",
    },
    {
        icon: <FaMedal />,
        title: 'Proven Track Record',
        desc: 'Over 500 successful engagements across 12 years, spanning private sector, government, and international development.',
    },
    {
        icon: <FaRocket />,
        title: 'End-to-End Delivery',
        desc: 'From initial strategy through execution to post-project support — we stay with you until results are delivered.',
    },
];

function WhyUs() {
    const sectionRef = useRef(null);

    useEffect(() => {
        const el = sectionRef.current;
        if (!el) return;
        const targets = el.querySelectorAll('.fade-up');
        const observer = new IntersectionObserver(
            entries => entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); observer.unobserve(e.target); } }),
            { threshold: 0.1 }
        );
        targets.forEach(t => observer.observe(t));
        return () => observer.disconnect();
    }, []);

    return (
        <section id="whyus" className="section" ref={sectionRef}>
            <div className="text-center fade-up">
                <p className="section-label">Why Choose Us</p>
                <h2 className="section-title">
                    The <span className="gradient-text">Connect All</span> Difference
                </h2>
                <p className="section-subtitle">
                    We don't just consult — we partner with you to deliver measurable,
                    lasting impact.
                </p>
            </div>

            <div className="whyus-grid">
                {REASONS.map((r, i) => (
                    <div key={i} className={`whyus-card fade-up delay-${i + 1}`}>
                        <div className="whyus-icon">{r.icon}</div>
                        <h3>{r.title}</h3>
                        <p>{r.desc}</p>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default WhyUs;
